'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherMenu } from '@subframe/core';
import React from 'react';
import Image from 'next/image';
import { IconButton } from '@/shared/components/ui/common/IconButton';
import * as SubframeUtils from '@/shared/components/ui/utils';
interface MobileNavbarProps {
  onMenuClick: () => void;
  className?: string;
}
export const MobileNavbar: React.FC<MobileNavbarProps> = t0 => {
  const $ = _c(11);
  const {
    onMenuClick,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = SubframeUtils.twClassNames("fixed top-0 right-0 left-0 z-50 flex h-16 w-full items-center justify-between border-b border-solid border-neutral-200 bg-white px-4 shadow-sm lg:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherMenu />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onMenuClick) {
    t3 = <IconButton icon={t2} onClick={onMenuClick} variant="neutral-tertiary" size="medium" aria-label="Abrir menu" />;
    $[3] = onMenuClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src="/Logo.svg" alt="Arbitralis" width={120} height={24} className="h-6 w-auto" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="flex items-center gap-3">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <nav className={t1}>{t5}</nav>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};